<div class="chat-bot-header">
  <div class="chat-menu" [class.disabled]="isInprogress()">
    @if (showMenuBtn()) {
      <mat-icon class="menu-action" (click)="toggleLeftPanel()">menu</mat-icon>
    }
    @if (showBackBtn()) {
      <mat-icon class="menu-action" (click)="toggleBackBtn()">arrow_back</mat-icon>
    }
    @if (pageTitle()) {
      <div class="page-title">
        <ng-container>
          <span class="page-title-text">{{ pageTitle() }}</span>
        </ng-container>
      </div>
    }
  </div>
  @if (showTitle()) {
    <span class="chat-title">
      <mat-icon class="ellis-ai" svgIcon="ellis-ai-v2"></mat-icon>
      Ellis AI
    </span>
  }
  <div class="chat-actions">
    <mat-icon svgIcon="new-chat-v1" fill="red" (click)="newSession()" [class.disabled]="isInprogress()"></mat-icon>

    <mat-icon
      svgIcon="{{ windowSizeIncreased ? 'window-size-dec' : 'window-size-inc' }}"
      (click)="toggleWindowSize()"
      [class.disabled]="isInprogress()"
    ></mat-icon>
    @if (showCloseBtn()) {
      <mat-icon (click)="closeChat()">close</mat-icon>
    }
  </div>
</div>
